// dependencies
import React, { useMemo, Fragment } from "react";
import { useIntl } from "react-intl";
import { StyleSheet, css } from "aphrodite";

// helpers
import { bookingGetChildrenYearList } from "../../../helpers/booking";

// constants
import theming from "@cloudspire/legacy-resources/src/constants/theming";

const { useTheme } = theming;

type PropsType = {
  numberOfChildren: number;
  name: string;
  value: string[];
  onChange;
};

const styles = StyleSheet.create({
  textInput: {
    appearance: "none",
    borderStyle: "dashed",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingRight: "0.3125rem",
    paddingLeft: "0.3125rem",
    maxWidth: "4.5rem",
    fontWeight: 300,
    textAlign: "center",
    backgroundColor: "transparent",
    borderRadius: 0,
    fontSize: "1rem",
  },
});

const MAX_CHILDREN_AGE = 18;

const ChildrenAge: React.FunctionComponent<PropsType> = (props) => {
  const { value, name, numberOfChildren, onChange } = props;

  const theme = useTheme();

  const intl = useIntl();

  const dynamicStyles = useMemo(
    () =>
      StyleSheet.create({
        textInput: {
          borderColor: theme.PRIMARY_COLOR_TEXT,
          fontFamily: theme.FONT_FAMILY,
        },
      }),
    [theme]
  );

  /**
   * Gère le changement de valeur.
   */
  function handleChange(index, event) {
    const newValue = [...value];

    newValue[index] = event.target.value;

    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  }

  return (
    <>
      {intl.formatMessage(
        {
          defaultMessage:
            "{numberOfChildren, plural, =0 {L'enfant a} one {L'enfant est né en } other {Les enfants sont nés en }}",
        },
        { numberOfChildren }
      )}
      {Array(numberOfChildren)
        .fill(null)
        .map((_, index) => {
          return (
            <select
              key={index}
              name={`${name}[${index}]`}
              className={css(styles.textInput, dynamicStyles.textInput)}
              value={value[index]}
              onChange={(event) => handleChange(index, event)}
            >
              <option label={""} value="" />
              {bookingGetChildrenYearList({
                maxChildrenAge: MAX_CHILDREN_AGE,
              }).map((year) => {
                return <option key={year} value={year}>{`${year}`}</option>;
              })}
            </select>
          );
        })
        .map((input, index, { length }) => {
          return (
            <Fragment key={index}>
              {index > 0 && index < length - 1 && ", "}
              {index === length - 1 &&
                length > 1 &&
                intl.formatMessage({
                  defaultMessage: " et ",
                })}
              {input}
            </Fragment>
          );
        })}
    </>
  );
};

export default ChildrenAge;
